<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg :headerText="lbl.register.title.register" isShowLangSwitch></TopBarBg>
        <PageContent class="px-8 flex-auto" :hasPoweredBy="hasPoweredBy" rounded>
            <div class="text-center text-base text-primary font-semibold mb-4">{{ lbl.register.body.fillEng }}</div>
            <div class="mt-1">
                <RegisterForm ref="form" :modalController="modalController"></RegisterForm>
            </div>
            <div class="mt-4">
                <div>
                    <Checkbox class="mb-4" v-model="acceptTerms" lazy :allowClickLabel="false" @toggle="onToggleTerms($event)"
                        ref="checkboxTerms">
                        <template #label>
                            <span class="text-base text-primary" v-html="lbl.register.body.term"
                                @click="onClickLabel($event)"></span>
                        </template>
                    </Checkbox>
                    <Checkbox class="mb-4" v-model="acceptPrivacy" lazy :allowClickLabel="false" @toggle="onTogglePrivacy($event)"
                        ref="checkboxTerms">
                        <template #label>
                            <span class="text-base text-primary" v-html="lbl.register.body.privacy"
                                @click="onClickLabel($event)"></span>
                        </template>
                    </Checkbox>
                    <Checkbox class="mb-4" v-model="acceptMarketing" lazy :allowClickLabel="false" @toggle="onToggleMarkering($event)"
                        ref="checkboxTerms">
                        <template #label>
                            <span class="text-base text-primary" v-html="lbl.register.body.marketing"
                                @click="onClickLabel($event)"></span>
                        </template>
                    </Checkbox>
                </div>
                <TermsAndCondition ref="termsAndPrivacy"
                    v-model:terms="acceptTerms"
                    v-model:privacy="acceptPrivacy"
                    v-model:marketing="acceptMarketing"
                    :showAcceptButton="true"
                    :modalController="modalController">
                </TermsAndCondition>
            </div>
            <div class="mt-4">
                <VBtn blocked large variant="primary" @click="register()">{{ lbl.register.buttons.register }}</VBtn>
            </div>

            <PowerByBzbs></PowerByBzbs>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>
        <VBottomSheet v-model="bottomSheetSuccess" :persistent="false">
            <div class="px-6 -mt-10 text-center">
                <div class="mb-4">
                    <img src="@/assets/icon/dialog/success.svg" class="w-20 h-20 mx-auto" alt />
                </div>
                <div>
                    <div class="text-lg text-primary uppercase" v-html="lbl.register.bottomSheet.txtSuccess"></div>
                    <div class="mt-6 mb-8 text-gray-secondary">{{ lbl.register.bottomSheet.txtConnecting }}</div>
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>
    </div>
</template>

<script>

import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue"
import PageContent from "@/components/Layout/Content/PageContent.vue"
import Footer from "@/components/Layout/Footer/Footer.vue"
import RegisterForm from "../component/RegisterForm.vue"
import TermsAndCondition from "../component/TermsAndCondition.vue"
import VBtn from "@/components/Button/VBtn.vue"
import Checkbox from "@/components/Input/simple/Checkbox.vue"
import ModalMaster from "@/components/Modal/ModalMaster.vue"
import VBottomSheet from "@/components/Dialog/BottomSheet.vue"
import PowerByBzbs from "@/components/Layout/Footer/PowerByBzbs.vue"

// mixin
import ModalMixin from "@/mixin/ModalMixin"
import LocaleMixin from "@/mixin/LocaleMixin"
import ErrorApiMixin from "@/mixin/ErrorApiMixin"

// helper
import CacheHelper from "@/helper/CacheHelper"
import Utility from "@/helper/Utility"
import DatetimeHelper from "@/helper/DatetimeHelper"
import LineFunction from "@/helper/facade/LineFunction"

// service
import BzbsProfile from "@/core/Account/service/BzbsProfile"
import BzbsAuth from "@/core/Account/service/BzbsAuth"
import { RegisterCardResponseModel } from "@/core/Account/model/RegisterCardModel"

// composables
import useRegisterCardComposable from "@/composables/RegisterCardComposable"

export default {
    name: "RegisterMainPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        RegisterForm,
        TermsAndCondition,
        VBtn,
        Checkbox,
        ModalMaster,
        VBottomSheet,
        PowerByBzbs
    },
    data: function () {
        return {
            hasPoweredBy: false,
            acceptCondition: false,
            bottomSheetSuccess: false,
            lineFunction: new LineFunction(),
            acceptTerms: false,
            acceptPrivacy: false,
            acceptMarketing: false,
        }
    },
    beforeRouteEnter(to, from, next) {
        var cache = new CacheHelper('session')
        let idToken = cache.getCache('LineIdToken')
        if (idToken == null || idToken == undefined) {
            //next()
            // redirect to line login
            next({
                path: "/linelogin",
                query: {
                    target_page: "register"
                }
            })
        } else {
            next()
        }
    },
    setup: function () {
        const { apiRegisterCreditCard, apiVerifyCreditCard } = useRegisterCardComposable()

        return {
            apiRegisterCreditCard,
            apiVerifyCreditCard
        }
    },
    mounted: function(){
        Utility.scrollTop()
        this.$refs.form.setValuesFromCache()
    },
    methods: {
        /**
         * @param {UIEvent} e
         */
        onClickLabel: function (e) {
            /**@type HTMLElement */
            let target = e.target
            // console.log(target.classList.contains("label-terms"))
            if (target.classList.contains("label-terms")) {
                this.$refs.termsAndPrivacy.showTerms()
            } else if (target.classList.contains("label-privacy")) {
                this.$refs.termsAndPrivacy.showPrivacy()
            } else {
                this.$refs.termsAndPrivacy.showMarketing()
            }
        },
        onToggleTerms: function (val) {
            console.log(val);
            if (val) {
                this.$refs.termsAndPrivacy.showTerms()
            } else {
                // clear value
                this.acceptTerms = false;
            }
        },
        onTogglePrivacy: function (val) {
            console.log(val);
            if (val) {
                this.$refs.termsAndPrivacy.showPrivacy()
            } else {
                // clear value
                this.acceptPrivacy = false;
            }
        },
        onToggleMarkering: function (val) {
            if (val) {
                this.$refs.termsAndPrivacy.showMarketing()
            } else {
                // clear value
                this.$refs.termsAndPrivacy.clearMkt()
                this.acceptMarketing = false;
            }
        },
        register: function () {
            // this.bottomSheetSuccess = true
            // return

            let data = this.$refs.form.getData();
            // console.log(data)
            if (data != null) {

                // check customer age
                let age = DatetimeHelper.getCalculateAge(data.strBirthDate)
                // console.log(age)
                if (age < 18) {
                    this.modalController.alertBottomModal.setMsg(this.lbl.register.errUnder18).show()
                    // don't continue
                    return
                } else {
                    if (this.acceptTerms && this.acceptPrivacy) {
                        // check line id token before call api register
                        this.validateLineIdToken((lineIdToken) => {
                            let pdpaVersions = this.$refs.termsAndPrivacy.getVersions()

                            // set data
                            //var cache = new CacheHelper('session')
                            let token = lineIdToken //cache.getCache('LineIdToken')
                            // validate line token here before go next flow

                            data.setIdToken(token)
                            data.setTermsVersion(pdpaVersions.terms)
                            data.setPrivacyVersion(pdpaVersions.privacy)
                            data.setMarketingVersion(pdpaVersions.marketing, pdpaVersions.marketingVersion);

                            let params = data.getParams()
                            this.apiRegister(params)
                        })
                    } else {
                        this.alertBottomModal.clearModal()
                            .setMsg("Please accept terms & privacy")
                            .show();
                    }
                }
            }
        },
        validateLineIdToken: function (callback) {
            // validate token here
            this.lineFunction.init(this.lineFunction.getLiffId()).then(() => {
                if (this.lineFunction.isTokenExpire()) {
                    this.reflowRegister()
                } else {
                    let idToken = this.lineFunction.getIdToken()
                    callback(idToken)
                }
            })
        },
        reflowRegister: function () {
            // save cache user info to session storage then redirect to login
            /**@type {import("../model/RegisterModel").RegisterModel} */
            let data = this.$refs.form.getData()
            if(data != null){
                // save cache then redirect
                data.setCache()
            }
            this.$router.replace({
                path: "/linelogin",
                query: {
                    target_page: "register"
                }
            })
        },
        apiRegister: function (params) {
            // console.log(params)
            this.loadingModal.show()

            BzbsProfile.registerUserWithParams(params).subscribe({
                next: () => {
                    this.loadingModal.hide()
                    // console.log(data)
                    this.bottomSheetSuccess = true

                    // login by line id token to get user token then call register card
                    this.loginLine()
                },
                error: (err) => {
                    this.loadingModal.hide()

                    // console.log(err)
                    if (err.id == 2078) {
                        this.alertBottomModal
                            .setTitle(this.lbl.default.error)
                            .setMsg(this.lbl.register.errPhoneNumberDuplicated)
                            .onClose(() => {
                                this.alertBottomModal.hide()
                            })
                            .show()
                    }
                    else if (err.id == 2089) {
                        this.alertBottomModal
                            .setTitle(this.lbl.default.error)
                            .setMsg(this.lbl.register.errEmailDuplicated)
                            .onClose(() => {
                                this.alertBottomModal.hide()
                            })
                            .show()
                    }
                    else if (err.error != null && err.error.data != null && err.error.data.code == "1904") {
                        this.alertBottomModal
                            .setTitle(this.lbl.default.error)
                            .setMsg(this.lbl.register.errLineDuplicated)
                            .onClose(() => {
                                this.goProfilePage()
                            })
                            .show()
                    }
                    else {
                        this.errorApi(err, true, { title: this.lbl.default.error })
                    }

                },
                complete: () => {
                    this.loadingModal.hide()
                }
            })
        },

        doRegisterCard: function (token) {
            let baseUrl = Utility.getWebUrl("webhooks")
            // baseUrl = "https://localhost:5001/webhooks"
            let cache = new CacheHelper("session")
            let targetPage =
                cache.getCache("special4you.redirect.target_page") || "profile"
            let returnUrl =
                baseUrl +
                "/RegisterdCard?target_page=" +
                encodeURIComponent(targetPage)

            this.apiRegisterCreditCard(token, returnUrl).then((resp) => {
                // console.log(resp)
                if (resp.success) {
                    let data = new RegisterCardResponseModel(resp.data)
                    let cache = new CacheHelper("session")
                    cache.setCache("registerCard.transId", data.tranId)

                    window.location = data.webPaymentUrl
                }
            }).catch((err) => {
                this.errorApi(err, true, { title: this.lbl.default.error })
            })
        },

        loginLine: function () {
            var cache = new CacheHelper('session')
            let idToken = cache.getCache('LineIdToken')

            BzbsAuth.apiLoginLine(idToken).subscribe((data) => {
                this.doRegisterCard(data.token)
            }, (err) => {
                this.errorApi(err, true, { title: this.lbl.default.error })
            });
        },

        goProfilePage: function () {
            this.$router.replace({
                name: "linelogin",
                query: {
                    target_page: "profile"
                }
            })
        }
    }
}
</script>
